import { SET_CLIENT_METADATA } from 'root/src/client/logic/app/actionIds'
import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { setClientMetadata } = appStoreLenses

export default {
	[SET_CLIENT_METADATA]: (state, clientMetadata) => setClientMetadata(clientMetadata, state),
}
